import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCloneScenarioPlanner } from './use-scenario-planner.hook';

/**
 * Provides the right handlers to open clone popup.
 * Handler to clone the scenario.
 * Handler to navigate to the mass edit scenario.
 * @param selectedScenarioId
 * @param shareKey
 * @returns
 */
export const useScenarioPlannerCloneHandler = (
  selectedScenarioId: string | null,
  shareKey?: string,
) => {
  const navigate = useNavigate();

  const [showCopyModal, setShowCopyModal] = useState(false);
  const scenarioCloneMutation = useCloneScenarioPlanner();

  // Handle openning scenario details.
  const handleOpenScenarioPlanner = useCallback(
    (id: string) => {
      navigate({ pathname: `/t/s/${id}`, search: 'nav=0&e=reset' });
    },
    [navigate],
  );

  // Create function to handle scenario cloning
  const handleCloneScenario = useCallback(
    (name: string) => {
      if (!selectedScenarioId) return;

      scenarioCloneMutation.mutate(
        { id: selectedScenarioId, name, shareKey },
        {
          onSuccess: (data) => {
            setShowCopyModal(false);
            // Navigate to the newly created scenario
            if (data.scenarioPlanner?.id) {
              handleOpenScenarioPlanner(data.scenarioPlanner.id);
            }
          },
          onError: () => {
            // TODO: Handle error
          },
        },
      );
    },
    [
      selectedScenarioId,
      scenarioCloneMutation,
      shareKey,
      handleOpenScenarioPlanner,
    ],
  );

  return {
    handleCloneScenario,
    handleOpenScenarioPlanner,
    showCopyModal,
    setShowCopyModal,
  };
};
